<template>
  <div class="">
    <QtyControls
      :value="count"
      v-bind="{ ...$attrs }"
      :min="min"
      :max="maxQuantity"
      :step="step"
      :show-step-count="false"
      :inverted="type === 'product-card'"
      :variant="'secondary'"
      :disabled="!stock"
      @input="changeCount"
    >
      <template #empty>
        <slot name="empty-place-holder" />
      </template>
    </QtyControls>
  </div>
</template>
<script setup lang="ts">
import type { EnteredOptionInput, CustomizableOptionInput } from '@robustastudio/e-commerce/common';
import type { PropType } from 'vue';

/**
 *
 * @description this one controls the amount of items to be added to the cart through the qty controls
 *
 * @case when the product min amount on cart is reached - toggle the remove from cart button
 */

const props = defineProps({
  sku: {
    type: String,
    required: true,
  },
  // eslint-disable-next-line vue/require-default-prop
  parentSku: {
    type: String,
    required: false,
  },
  min: {
    type: Number,
    required: true,
  },
  max: {
    type: Number,
    required: true,
  },
  step: {
    type: Number,
    required: true,
  },
  stock: {
    type: Number,
    required: true,
  },
  type: {
    type: String,
    required: false,
    default: '',
  },

  /**
   *
   * Entered Options
   */
  options: {
    type: Object as PropType<{
      entered_options?: Array<EnteredOptionInput>;
      customizable_options?: Array<CustomizableOptionInput>;
    }>,
    default: () => ({}),
  },
});
const { count, requestChangeCount, maxQuantity } = useQuantityControl(
  computed(() => props.sku),
  computed(() => props.max),
  computed(() => props.min),
  computed(() => props.stock),
  props.parentSku,
  computed(() => props.options),
);
const { emit } = useEventBus();

async function changeCount(value: number) {
  await requestChangeCount(value);
  emit('ITEM_ADDED');
}
</script>

<i18n>
{
  "en": {
    "addToCart": "Add to cart"
  }
}
</i18n>
